export default __webpack_public_path__ + "src/docs/packages/qambathi-mountain-lodge.pdf";